export const competencyGroups = [
  {
    competencyGrouping: "Asset and Inventory Management",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the process of identifying, developing, operating, maintaining, upgrading, and disposing of assets.",
    competencies: [
      {
        competencyTitle: "Asset Lifecycle Management",
        competencyTitleDescription:
          "The ability to establish and implement processes and policies for managing cybersecurity assets throughout their lifecycle, from acquisition and deployment to maintenance, usage, and secure disposal, ensuring accountability, security, and compliance.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Inventory Control Systems",
        competencyTitleDescription:
          "The ability to effectively utilize tools and methodologies to monitor, organize, and maintain accurate records of cybersecurity asset inventory levels, usage, and configuration, ensuring data integrity and supporting asset management processes.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Asset Valuation and Prioritization",
        competencyTitleDescription:
          "The ability to assess the business value of cybersecurity assets and prioritize their importance based on organizational goals, risk assessments, and potential impact of compromise.",
        type: "Non Technical",
      },
    ],
  },

  {
    competencyGrouping: "Business Continuity",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to business continuity planning and continuity of operations to help ensure an organization can prevent and overcome serious incidents or disasters and quickly resume normal operations within a reasonable timeframe.",
    competencies: [
      {
        competencyTitle: "Disaster Recovery Planning",
        competencyTitleDescription:
          "The ability to develop, implement, and test disaster recovery plans that enable rapid resumption of essential operations after a disruptive event, minimizing downtime and data loss.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Contingency Planning",
        competencyTitleDescription:
          "The ability to develop and implement contingency plans that address potential disruptions to business operations, outlining alternative procedures, resources, and strategies to maintain essential functions during unforeseen events.",
        type: "Non Technical",
      },
      {
        competencyTitle: "TableTop Exercise Management",
        competencyTitleDescription:
          "The ability to design, facilitate, and evaluate cybersecurity tabletop exercises to test and improve an organization's incident response plans, communication protocols, and decision-making processes in a simulated crisis environment.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Cyber Resilience",
        competencyTitleDescription:
          "The ability to anticipate, absorb, adapt to, and rapidly recover from cyber incidents while maintaining critical operations. This includes strengthening systems and processes to withstand attacks, minimizing impact, and ensuring continuity despite persistent threats.",
        type: "Non Technical",
      },
    ],
  },

  {
    competencyGrouping: "Data Collection Operations",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to executing the collection of cybersecurity information to develop intelligence using appropriate strategies and within the priorities established through the collection management process. ",
    competencies: [
      {
        competencyTitle: "Data Collection Techniques",
        competencyTitleDescription:
          "The ability to effectively and ethically utilize a variety of data collection techniques, including open-source intelligence (OSINT), network traffic analysis, log analysis, and vulnerability scanning, to gather relevant cybersecurity information within established priorities and legal/ethical boundaries.",
        type: "Technical",
      },
      {
        competencyTitle: "Collection Methodology Evaluation",
        competencyTitleDescription:
          "The ability to critically evaluate and optimize the effectiveness and efficiency of cybersecurity information collection methodologies, assessing their strengths, weaknesses, and suitability for specific intelligence requirements.",
        type: "Technical",
      },
      {
        competencyTitle: "Information Source Evaluation",
        competencyTitleDescription:
          "The ability to analyze and evaluate the credibility, reliability, and relevance of various information sources to ensure the collection of actionable and accurate cybersecurity intelligence.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Data Analysis",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to systematically applying statistical and logical techniques to describe, illustrate, condense, summarize, and evaluate data. The synthesis and analysis of various types of data to reach a decision, make a recommendation, or to compile reports, briefings, executive summaries, and other correspondence to support organizational work, goals, and plans.",
    competencies: [
      {
        competencyTitle: "Statistical Analysis",
        competencyTitleDescription:
          "The ability to apply statistical methods to analyze cybersecurity data, identify trends, anomalies, and patterns, and inform decision-making.",
        type: "Technical",
      },
      {
        competencyTitle: "Data Visualization",
        competencyTitleDescription:
          "The ability to create compelling visual representations of complex cybersecurity data, such as charts, graphs, and dashboards, to communicate findings clearly and effectively to diverse audiences, enabling data-driven decision-making.",
        type: "Technical",
      },
      {
        competencyTitle: "Big Data and Machine Learning",
        competencyTitleDescription:
          "The ability to leverage big data analytics and machine learning techniques to identify and mitigate advanced cybersecurity threats, such as using behavioral pattern analysis to detect insider threats.",
        type: "Technical",
      },
      {
        competencyTitle: "Data Cleaning and Preprocessing",
        competencyTitleDescription:
          "The ability to prepare raw cybersecurity data for analysis by ensuring its accuracy, consistency, and reliability, including techniques like filtering logs to remove irrelevant information.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Data Management",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the development and execution of data management plans, programs, practices, processes, architectures, and tools across all stages of the data lifecycle. Includes processes around the creation, storage, archiving, discovery, access, disposal, enhancement, and reuse of data and information assets.",
    competencies: [
      {
        competencyTitle: "Data Governance",
        competencyTitleDescription:
          "The ability to establish and enforce data governance policies and processes for cybersecurity information, ensuring data integrity, security, usability, and compliance with relevant regulations and organizational standards throughout the data lifecycle",
        type: "Technical",
      },
      {
        competencyTitle: "Data architecture",
        competencyTitleDescription:
          "The ability to design, implement, and manage secure and scalable cybersecurity data architectures, ensuring data integrity, availability, and alignment with organizational goals and regulatory requirements.",
        type: "Technical",
      },
      {
        competencyTitle: "Data lifecycle management",
        competencyTitleDescription:
          "The ability to effectively manage cybersecurity data throughout its lifecycle, from creation and collection to storage, processing, archiving, and secure disposal, ensuring data integrity, confidentiality, and availability while adhering to regulatory requirements and organizational policies.",
        type: "Technical",
      },
      {
        competencyTitle: "Data integration",
        competencyTitleDescription:
          "The ability to effectively integrate cybersecurity data from disparate sources, such as threat intelligence feeds, security logs, and vulnerability scans, to create unified and usable datasets that enhance analysis, reporting, and security operations.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Data Privacy",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the proper handling of data to protect individuals' privacy, including addressing whether and how data is shared and with whom; how data is collected and stored; and legal and regulatory compliance.",
    competencies: [
      {
        competencyTitle: "Regulatory Compliance and Data Protection Frameworks",
        competencyTitleDescription:
          "The ability to implement and maintain data governance practices that comply with global and regional privacy regulations (Eg: GDPR)",
        type: "Non Technical",
      },
      {
        competencyTitle: "Data Sovereignty and Jurisdictional Requirements",
        competencyTitleDescription:
          "The ability to identify, assess, and implement controls ensuring that data is collected, processed, stored, and transferred in accordance with relevant jurisdictional laws and cross-border data flow restrictions.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Data Privacy Standards and Certifications",
        competencyTitleDescription:
          "The ability to apply industry-specific privacy standards and certification frameworks such as NIST, SOC2",
        type: "Non Technical",
      },
    ],
  },
  {
    competencyGrouping: "Data Security",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the methods and procedures that protect data and information systems by ensuring their confidentialty, integrity, and availability.",
    competencies: [
      {
        competencyTitle: "Encryption and Data Protection",
        competencyTitleDescription:
          "The ability to implement and manage encryption and data protection techniques to secure cybersecurity data in transit, at rest, and in use, preventing unauthorized access and preserving confidentiality and integrity.",
        type: "Technical",
      },
      {
        competencyTitle: "Access and Identity Management",
        competencyTitleDescription:
          "The ability to design, implement, and manage access control policies and Identity and Access Management (IAM) systems, ensuring that only authorized users can access sensitive data and systems, leveraging least privilege, multi-factor authentication (MFA), and single sign-on (SSO).",
        type: "Technical",
      },
      {
        competencyTitle: "Cloud and Infrastructure Data Security",
        competencyTitleDescription:
          "The ability to apply robust security measures to protect cybersecurity data in cloud environments (SaaS, PaaS, IaaS) and across critical national infrastructure sectors such as energy, healthcare, and transportation.",
        type: "Technical",
      },
      {
        competencyTitle: "Data Loss Prevention (DLP)",
        competencyTitleDescription:
          "The ability to deploy and manage tools and techniques that prevent unauthorized use, transfer, or disclosure of sensitive data, maintaining compliance and minimizing risk.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Modern Security Practices",
    competencyGroupingDescription:
      "This competency describes a learner's capabilities in applying cybersecurity principles across modern technology environments, including software development, data management, and emerging technologies such as artificial intelligence.",
    competencies: [
      {
        competencyTitle: "Application Security",
        competencyTitleDescription:
          "The ability to design, develop, and assess secure software applications, incorporating secure coding practices, code analysis tools, and awareness of vulnerabilities such as those in the OWASP Top 10.",
        type: "Technical",
      },
      {
        competencyTitle: "DevSecOps",
        competencyTitleDescription:
          "The ability to embed security controls and practices into development and operations pipelines, integrating security testing and automation within CI/CD workflows.",
        type: "Technical",
      },
      {
        competencyTitle: "Data Classification",
        competencyTitleDescription:
          "The ability to categorize and label data based on its sensitivity, regulatory requirements, and business value, enabling appropriate protection strategies across its lifecycle.",
        type: "Technical",
      },
      {
        competencyTitle: "AI Data Security",
        competencyTitleDescription:
          "The ability to identify and mitigate risks specific to artificial intelligence systems, including protecting training data, securing models, and defending against adversarial attacks and data poisoning.",
        type: "Technical",
      },
      {
        competencyTitle: "Adversary Emulation",
        competencyTitleDescription:
          "The ability to mimic adversarial behaviors to evaluate and enhance the organization's resilience. It includes conducting red team exercises, creating threat profiles, executing simulated attacks, and validating defenses to identify gaps and improve detection capabilities.",
      },
    ],
  },
  {
    competencyGrouping: "Digital Forensics",
    competencyGroupingDescription:
      "This competency describes a learner's capabilities related to the application of tools and techniques used in the collection, preservation, analysis, and presentation of digital evidence.",
    competencies: [
      {
        competencyTitle: "Digital Evidence Collection & Preservation",
        competencyTitleDescription:
          "The ability to systematically collect, preserve, and safeguard digital evidence using appropriate tools and methodologies, ensuring its integrity, authenticity, and admissibility for forensic analysis and legal proceedings.",
        type: "Technical",
      },
      {
        competencyTitle: "Malware and Artifact Analysis",
        competencyTitleDescription:
          "The ability to extract, examine, and interpret data from malicious code, system artifacts, and compromised devices to identify threats, determine attack vectors, and support remediation or prosecution efforts.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Cybersecurity Awareness Training",
    competencyGroupingDescription:
      "This Competency describes a learner's ability to design, deliver, and evaluate training programs that educate individuals on recognizing, preventing, and responding to cybersecurity threats to foster a culture of security awareness.",
    competencies: [
      {
        competencyTitle: "Secure Behavior Advocacy",
        competencyTitleDescription:
          "The ability to promote and instill safe practices and adherence to organizational security policies, to encourage a proactive security mindset.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Phishing Simulation Management",
        competencyTitleDescription:
          "The ability to design, implement, and analyze phishing simulation programs to test and enhance individuals' awareness of phishing threats, measure their susceptibility, and provide targeted feedback to improve security behaviors.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Security Awareness Training Development & Deployment",
        competencyTitleDescription:
          "The ability to design, create, and implement comprehensive training programs that educate individuals on security best practices, tailored to organizational needs, and delivered effectively to foster a culture of cybersecurity awareness.",
        type: "Non Technical",
      },
    ],
  },
  {
    competencyGrouping: "Encryption",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the cryptographic process of transforming data to ensure that it can only be read by the person who is authorized to access it.",
    competencies: [
      {
        competencyTitle: "Encryption Protocols & Standards",
        competencyTitleDescription:
          "The ability to apply encryption frameworks and standards, such as TLS, IPSec, and PKI, to secure data transmission and storage.",
        type: "Technical",
      },
      {
        competencyTitle: "Key Management",
        competencyTitleDescription:
          "The ability to implement and manage secure key management processes, including generation, storage, distribution, rotation, and revocation of cryptographic keys.",
        type: "Technical",
      },
      {
        competencyTitle: "Encryption Methods & Applications",
        competencyTitleDescription:
          "The ability to understand and apply symmetric and asymmetric encryption techniques to secure data and ensure confidential information exchange.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Enterprise Architecture",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the principles, concepts, and methods of enterprise architecture to align technology strategy, plans, and systems with the mission, goals, structure, and processes of the organization.",
    competencies: [
      {
        competencyTitle: "Cloud & Hybrid Infrastructure Integration",
        competencyTitleDescription:
          "The ability to develop and implement enterprise architectures that support secure cloud adoption, hybrid IT environments, and digital transformation initiatives within Ireland's public and private sectors.",
        type: "Technical",
      },
      {
        competencyTitle:
          "Critical National Infrastructure (CNI) Security Architecture",
        competencyTitleDescription:
          "The ability to design resilient and secure architectures for Ireland's key industries, including finance, healthcare, and energy, ensuring robust protections against cyber threats targeting essential services.",
        type: "Technical",
      },
      {
        competencyTitle: "Enterprise Security Architecture Design",
        competencyTitleDescription:
          "The ability to develop and implement security-focused enterprise architectures that integrate zero-trust principles, secure-by-design methodologies, and resilience strategies to protect Irish businesses and public sector organizations from evolving cyber threats.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Emerging Technologies Security",
    competencyGroupingDescription:
      "This section addresses the security challenges and competencies required to safeguard emerging technologies, including AI, Quantum Computing, and Blockchain systems.",
    type: "MISSING",
    competencies: [
      {
        competencyTitle: "Quantum-Resistant Cryptography",
        competencyTitleDescription:
          "The ability to develop, implement, and manage cryptographic systems that are resistant to attacks by quantum computers. Includes awareness of post-quantum algorithms, migration planning, and ensuring backward compatibility.",
        type: "MISSING",
      },
      {
        competencyTitle: "Blockchain Security",
        competencyTitleDescription:
          "Description: The ability to secure blockchain technologies, ensuring integrity, confidentiality, and availability of decentralized systems. This includes smart contract security, consensus mechanism evaluation, and threat modeling.",
        type: "MISSING",
      },
      {
        competencyTitle: "AI Security",
        competencyTitleDescription:
          "The ability to design, implement, and protect AI systems from adversarial attacks, data poisoning, and model inversion. Involves techniques to enhance robustness, reliability, and ethical AI usage.",
        type: "MISSING",
      },
    ],
  },
  {
    competencyGrouping: "Identity Management",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the tools, policies, and systems that define, manage, and monitor the roles and secure access privileges of users, ensuring authorized people and things have the appropriate access to the correct protected resources at the correct time.",
    competencies: [
      {
        competencyTitle: "Access Control Strategies",
        competencyTitleDescription:
          "The ability to design and implement role-based, attribute-based, and risk-based access control models to ensure secure and efficient identity and access management.",
        type: "Technical",
      },
      {
        competencyTitle: "Identity Governance & Lifecycle Management",
        competencyTitleDescription:
          "The ability to manage the full identity lifecycle, including provisioning, deprovisioning, and enforcing policies for access reviews, segregation of duties, and regulatory compliance.",
        type: "Technical",
      },
      {
        competencyTitle: "Authentication & Authorization Technologies",
        competencyTitleDescription:
          "The ability to deploy and manage authentication mechanisms such as multi-factor authentication (MFA), passwordless authentication, and federated identity solutions to enhance security and user experience.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Incident Management",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the tactics, technologies, principles, and processes to analyze, prioritize, and handle cybersecurity incidents.",
    competencies: [
      {
        competencyTitle: "Incident Detection & Analysis",
        competencyTitleDescription:
          "The ability to identify, analyze, and categorize security events to determine their severity, impact, and appropriate response actions.",
        type: "Technical",
      },
      {
        competencyTitle: "Incident Response & Containment",
        competencyTitleDescription:
          "The ability to execute coordinated actions to mitigate, contain, and neutralize cybersecurity threats while minimizing operational disruption.",
        type: "Technical",
      },
      {
        competencyTitle: "Post-Incident Recovery & Lessons Learned",
        competencyTitleDescription:
          "The ability to restore affected systems, conduct forensic analysis, and implement corrective measures to enhance resilience and prevent recurrence.",
        type: "Technical",
      },
      {
        competencyTitle: "Digital Forensics",
        competencyTitleDescription:
          "The ability to collect, preserve, and analyze digital evidence following a cyber incident. It involves performing investigations, maintaining chain-of-custody, preparing forensic reports, and leveraging tools to uncover artifacts critical for incident response and remediation.\r\n",
      },
    ],
  },
  {
    competencyGrouping: "Information Systems and Network Security",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the methods, tools, and procedures—including development of information security plans—to detect, respond, and protect information, information systems, and networks from risks and to provide or restore security of information systems and network services.",
    competencies: [
      {
        competencyTitle: "Network Security Architecture & Design:",
        competencyTitleDescription:
          "The ability to develop and implement secure network infrastructures, incorporating firewalls, segmentation, and zero-trust principles to protect data and communications.",
        type: "Technical",
      },
      {
        competencyTitle: "Threat Modelling & Secure System Design",
        competencyTitleDescription:
          "The ability to systematically identify, analyze, and prioritize potential threats to information systems by evaluating assets, attack vectors, and security controls.",
        type: "Technical",
      },
      {
        competencyTitle: "Security Restoration & Recovery:",
        competencyTitleDescription:
          "The ability to implement processes, tools, and strategies to restore the security and functionality of compromised information systems and network services following cyber incidents or disruptions.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Infrastructure Design",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the architecture and topology of software, hardware, and networks, including LANS, WANS, and their components and associated protocols and standards, and how they operate and integrate with one another and with associated controlling software.",
    competencies: [
      {
        competencyTitle: "Secure Network Architecture",
        competencyTitleDescription:
          "The ability to design and implement resilient network infrastructures that incorporate security principles, segmentation, and access controls to mitigate cyber risks.",
        type: "Technical",
      },
      {
        competencyTitle: "Cloud and Virtualization Architecture",
        competencyTitleDescription:
          "The ability to develop and secure cloud-based and virtualized environments to ensure scalable, efficient, and compliant infrastructure solutions.",
        type: "Technical",
      },
      {
        competencyTitle: "Systems Integration",
        competencyTitleDescription:
          "The ability to ensure seamless integration of hardware, software, and network components across diverse environments, including cloud and on-premises infrastructure.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Intelligence Analysis",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the application of individual and collective cognitive methods to collect, process, and interpret data about an enemy to answer tactical questions about current operations or to predict future behavior.",
    competencies: [
      {
        competencyTitle: "Threat Intelligence Collection & Analysis",
        competencyTitleDescription:
          "The ability to apply structured methodologies to gather, validate, and analyze data from diverse intelligence sources (open-source, human, signals, and technical) to assess adversary capabilities, intentions, and tactics.",
        type: "Technical",
      },
      {
        competencyTitle: "Adversary Behavior Prediction & Profiling",
        competencyTitleDescription:
          "The ability to utilize data analytics, historical patterns, and behavioral indicators to anticipate threat actor movements, predict cyberattack strategies, and inform proactive defense measures.",
        type: "Technical",
      },
      {
        competencyTitle: "Operational Intelligence & Decision Support",
        competencyTitleDescription:
          "The ability to synthesize intelligence reports and real-time data to support tactical decision-making, enhance situational awareness, and provide actionable insights for security operations and incident response.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Law, Policy, and Ethics",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to awareness of and compliance with laws, regulations, policies, and ethics that can impact organizational activities.",
    competencies: [
      {
        competencyTitle: "Legal & Regulatory Compliance",
        competencyTitleDescription:
          "The ability to understand and apply relevant cybersecurity laws, regulations, and industry standards applicable in Ireland (e.g., GDPR, NIS2, DORA, EU AI Act) to ensure organizational adherence and mitigate risks.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Regulatory Reporting & Incident Disclosure",
        competencyTitleDescription:
          "The ability to identify and fulfill regulatory reporting obligations following cybersecurity incidents, including accurate and timely submissions to authorities in line with frameworks such as DORA, NIS2, and GDPR. Includes knowledge of thresholds, escalation procedures, and cross-border implications.",
      },
      {
        competencyTitle: "Policy Development & Governance",
        competencyTitleDescription:
          "The ability to create, implement, and maintain cybersecurity policies, guidelines, and governance frameworks that align with legal, regulatory, and ethical requirements, as well as organizational objectives.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Ethical & Risk-Based Decision-Making",
        competencyTitleDescription:
          "The ability to evaluate the ethical considerations and risk implications of cybersecurity actions, ensuring responsible decision-making that balances security, privacy, and business objectives.",
        type: "Non Technical",
      },
    ],
  },
  {
    competencyGrouping: "Modeling and Simulation",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to mathematical modeling and simulation tools and techniques to plan and conduct test and evaluation programs, characterize systems support decisions involving requirements, evaluate design alternatives, or support operational preparation.",
    competencies: [
      {
        competencyTitle: "Cyber Threat Modeling & Attack Simulation",
        competencyTitleDescription:
          "The ability to develop and apply models to simulate cyber threats, attack vectors, and adversary behaviors to assess vulnerabilities and improve security postures.",
        type: "Technical",
      },
      {
        competencyTitle: "Operational Testing & Validation",
        competencyTitleDescription:
          "The ability to design and conduct structured tests to evaluate cybersecurity controls, system resilience, and compliance with security requirements under controlled conditions.",
        type: "Technical",
      },
      {
        competencyTitle: "Scenario-Based Cyber Simulation",
        competencyTitleDescription:
          "The ability to create and execute real-world cyber threat scenarios to assess incident response effectiveness, security posture, and organizational readiness against evolving threats.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Network Management",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the operation, management, and maintenance of computer network and telecommunication systems and linked systems and peripherals.",
    competencies: [
      {
        competencyTitle: "Network Performance Monitoring & Threat Detection",
        competencyTitleDescription:
          "The ability to implement tools and methodologies to continuously monitor network traffic, analyze performance metrics, and detect anomalies to identify potential cyber threats, prevent DDoS attacks, and optimize network efficiency.",
        type: "Technical",
      },
      {
        competencyTitle: "Fault Detection & Secure Service Restoration",
        competencyTitleDescription:
          "The ability to apply structured fault detection processes and cybersecurity incident response protocols to diagnose network disruptions, isolate compromised systems, and restore secure and resilient network operations with minimal downtime.",
        type: "Technical",
      },
      {
        competencyTitle: "Network Security & Zero Trust Access Control",
        competencyTitleDescription:
          "The ability to design and enforce Zero Trust security frameworks to manage access controls, authenticate users and devices, and mitigate cyber threats through segmentation, encryption, and continuous verification of network activity.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Operations Support",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the policies and procedures used to ensure the production or delivery of products and services, including tools and mechanisms for distributing new or enhanced hardware and software.",
    competencies: [
      {
        competencyTitle: "Change & Patch Management",
        competencyTitleDescription:
          "The ability to manage the secure rollout of updates, patches, and system changes to maintain operational stability while mitigating vulnerabilities and minimizing disruptions.",
        type: "Technical",
      },
      {
        competencyTitle: "Service Continuity & Restoration",
        competencyTitleDescription:
          "The ability to implement structured recovery processes, tools, and technologies to restore critical IT services, systems, and infrastructure following disruptions, ensuring minimal downtime and sustained business operations.",
        type: "Technical",
      },
      {
        competencyTitle: "Secure Deployment & Configuration Management",
        competencyTitleDescription:
          "The ability to implement and maintain secure configurations for hardware, software, and network assets to ensure system integrity, availability, and compliance with security policies.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Policy Development",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the process of creating, communicating, and maintaining policies and procedures within an organization.",
    competencies: [
      {
        competencyTitle: "Policy and Procedure Development",
        competencyTitleDescription:
          "The ability to create effective and compliant policies and procedures, incorporating regulations, best practices, and stakeholder input.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Policy and Procedure Communication:",
        competencyTitleDescription:
          "The ability to effectively communicate policies and procedures to stakeholders through various channels.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Policy and Procedure Maintenance and Review:",
        competencyTitleDescription:
          "The ability to maintain and review policies and procedures, ensuring they remain current, effective, and aligned with best practices.",
        type: "Non Technical",
      },
    ],
  },
  {
    competencyGrouping: "Risk Management",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the principles, methods, and tools used for risk assessment and mitigation, including assessment of failures and their consequences. Includes the oversight, evaluation, and support of the documentation, validation, assessment, and authorization processes necessary to assure that existing and new technology systems meet organizational cybersecurity and risk requirements. ",
    competencies: [
      {
        competencyTitle: "Cyber risk assessment & analysis",
        competencyTitleDescription:
          "The ability to apply frameworks (e.g., NIST RMF, ISO 27005) and methodologies to identify, evaluate, and prioritize cybersecurity risks, including threat modeling and impact assessment.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Risk mitigation & control implementation",
        competencyTitleDescription:
          "The ability to develop and implement security controls, policies, and strategies (e.g., risk avoidance, transfer, acceptance, and mitigation) to reduce organizational exposure to cyber threats.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Enterprise-wide cyber risk governance",
        competencyTitleDescription:
          "The ability to establish and oversee risk management frameworks at scale, ensuring alignment with corporate governance, business continuity planning, and cross-functional risk committees.",
        type: "Non Technical",
      },
      {
        competencyTitle:
          "Cyber risk quantification & financial impact analysis",
        competencyTitleDescription:
          "The ability to utilize risk quantification models (e.g., FAIR, Monte Carlo simulations) to translate cybersecurity risks into financial terms, enabling data-driven decision-making for risk prioritization and cyber insurance considerations.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Third-party & supply chain risk management",
        competencyTitleDescription:
          "The ability to assess and mitigate cybersecurity risks associated with vendors, suppliers, and business partners by implementing due diligence, contractual security requirements, and continuous monitoring.",
        type: "Non Technical",
      },
    ],
  },
  {
    competencyGrouping: "Strategic Planning",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to formulating effective tactics and metrics associated with the vision, mission, goals, and objectives of the organization or business unit.",
    competencies: [
      {
        competencyTitle: "cybersecurity strategy development",
        competencyTitleDescription:
          "The ability to design and implement long-term cybersecurity roadmaps that align with organizational goals, industry best practices, and national security priorities in Ireland.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Data driven strategy -",
        competencyTitleDescription:
          "The ability to define key metrics, track cybersecurity program effectiveness, and continuously refine strategies based on data-driven insights and evolving threat landscapes.",
        type: "Non Technical",
      },
      {
        competencyTitle: "adaptive strategy management–",
        competencyTitleDescription:
          "The ability to establish feedback mechanisms to assess the effectiveness of cybersecurity strategies, incorporating lessons learned, emerging threats, and technological advancements to refine and evolve security initiatives over time.",
        type: "Non Technical",
      },
    ],
  },
  {
    competencyGrouping: "System Administration",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the installation, configuration, troubleshooting, and maintenance of computer systems to ensure their confidentiality, integrity, and availability. Includes the management of accounts, firewalls, and patches as well as access control, passwords, and account creation and administration.",
    competencies: [
      {
        competencyTitle: "secure system configuration & hardening",
        competencyTitleDescription:
          "The ability to implement security best practices, baseline configurations, and system hardening techniques to minimize vulnerabilities in operating systems, applications, and network devices.",
        type: "Technical",
      },
      {
        competencyTitle: "identity & access management (iam) administration",
        competencyTitleDescription:
          "The ability to manage user accounts, roles, and permissions using authentication, authorization, and access control policies to enforce least privilege and prevent unauthorized access",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Threat Analysis",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the identification and assessment of adversaries' or foreign intelligence entities' cybersecurity attack capabilities and activities. Includes awareness and evaluation of internal and external information vulnerabilities that may be at risk to cyber-attacks and the production of findings to help initialize or support law enforcement and counterintelligence investigations or activities.",
    competencies: [
      {
        competencyTitle: "cyber threat intelligence gathering & analysis",
        competencyTitleDescription:
          "The ability to collect, analyze, and contextualize threat intelligence from open-source, commercial, and classified sources to identify potential adversaries, tactics, techniques, and procedures (TTPs).",
        type: "Technical",
      },
      {
        competencyTitle: "attack surface mapping & vulnerability assessment",
        competencyTitleDescription:
          "The ability to identify and evaluate internal and external vulnerabilities, assets, and attack vectors to assess the likelihood and impact of cyber threats.",
        type: "Technical",
      },
      {
        competencyTitle: "adversary tracking & behavioral profiling",
        competencyTitleDescription:
          "The ability to monitor, analyze, and profile cyber threat actors, including their motives, infrastructure, and evolving tactics, to anticipate and mitigate potential attacks.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Vulnerabilities Assessment",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to the principles, methods, and tools for assessing vulnerabilities and developing or recommending appropriate mitigation countermeasures.",
    competencies: [
      {
        competencyTitle: "system & network vulnerability scanning",
        competencyTitleDescription:
          "The ability to utilize automated tools (e.g., Nessus, OpenVAS, Qualys) and manual techniques to identify security weaknesses across IT infrastructure, applications, and cloud environments.",
        type: "Technical",
      },
      {
        competencyTitle: "patch & vulnerability management",
        competencyTitleDescription:
          "The ability to continuously monitor, test, and apply security patches and updates to mitigate system vulnerabilities while ensuring operational stability and compliance with cybersecurity policies.",
        type: "Technical",
      },
      {
        competencyTitle: "remediation strategy & validation",
        competencyTitleDescription:
          "The ability to develop and execute plans to address identified vulnerabilities through patch management, secure configurations, or alternative controls while verifying the effectiveness of remediation through retesting and continuous monitoring.",
        type: "Technical",
      },
      {
        competencyTitle: "Penetration Testing",
        competencyTitleDescription:
          "This competency describes a learner's ability to conduct authorized simulated attacks on systems, networks, or applications to identify vulnerabilities, weaknesses, and potential exploit paths.",
      },
    ],
  },
  {
    competencyGrouping: "Security Architecture & Design",
    competencyGroupingDescription:
      "This Competency describes a learner's capabilities related to designing secure architectures across identity, network, cloud, application, and data domains, aligned with business objectives, compliance standards, and emerging threats.",
    competencies: [
      {
        competencyTitle: "IAM Architecture",
        competencyTitleDescription:
          "The ability to design secure and scalable Identity and Access Management solutions, integrating principles of least privilege, federation, MFA, and lifecycle management across systems and users.",
        type: "Technical",
      },
      {
        competencyTitle: "Network Security Architecture",
        competencyTitleDescription:
          "The ability to architect secure networks using segmentation, firewalls, zero trust, VPNs, and intrusion detection/prevention systems in hybrid or multi-cloud environments.",
        type: "Technical",
      },
      {
        competencyTitle: "Cloud Security Architecture",
        competencyTitleDescription:
          "The ability to develop cloud-native and hybrid security architectures in compliance with frameworks like CIS Benchmarks, CSA CCM, or ISO 27017, ensuring data protection, workload isolation, and secure configuration management.",
        type: "Technical",
      },
      {
        competencyTitle: "Application Security Architecture",
        competencyTitleDescription:
          "The ability to embed security principles into application and DevSecOps pipelines, including threat modeling, secure design patterns, and architecture-level mitigation strategies.",
        type: "Technical",
      },
      {
        competencyTitle: "Enterprise Security Architecture (ESA)",
        competencyTitleDescription:
          "The ability to align technical architectures with enterprise strategy and frameworks such as SABSA or TOGAF, ensuring long-term security posture, governance, and integration across the business.\r\n",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Specialized Cloud Security",
    competencyGroupingDescription:
      "This section focuses on competencies needed to protect cloud environments, including architecture, governance, and compliance.",
    competencies: [
      {
        competencyTitle: "Cloud Security Architecture Design",
        competencyTitleDescription:
          "The ability to design secure cloud architectures, ensuring the confidentiality, integrity, and availability of cloud-native and hybrid environments. Includes Infrastructure-as-Code (IaC) security, container security, and serverless security.",
        type: "Technical",
      },
      {
        competencyTitle: "Cloud Compliance & Governance",
        competencyTitleDescription:
          "The ability to establish and maintain compliance programs specific to cloud environments, ensuring adherence to frameworks such as GDPR, CMMC, SOC 2, and ISO 27001. Includes cloud governance policies, monitoring, and reporting.",
        type: "Technical",
      },
      {
        competencyTitle: "Cloud Incident Response & Forensics",
        competencyTitleDescription:
          "The ability to conduct incident response and forensic investigations in cloud environments. This includes preparation, detection, analysis, containment, eradication, and recovery specific to cloud systems.",
        type: "Technical",
      },
    ],
  },
  {
    competencyGrouping: "Governance",
    competencyGroupingDescription:
      "This Competency describes the ability to establish, implement, and maintain governance structures, policies, procedures, standards, and frameworks required to ensure an organization's cybersecurity practices align with legal, regulatory, and industry requirements.",
    competencies: [
      {
        competencyTitle: "Governance & Compliance",
        competencyTitleDescription:
          "The ability to establish, implement, and maintain policies, standards, and procedures to ensure compliance with applicable laws, regulations, and frameworks. Includes internal governance, third-party governance, and enterprise-wide cybersecurity oversight.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Privacy Protection",
        competencyTitleDescription:
          "The ability to implement controls and processes to ensure the privacy of data in compliance with regulations such as GDPR, HIPAA, and CCPA. Includes data anonymization, encryption, and data retention policies.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Auditing & Continious Improvement",
        competencyTitleDescription:
          "The ability to conduct regular audits and assessments to evaluate the effectiveness of cybersecurity policies and practices. Includes making improvements based on audit findings and evolving threats.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Organisational Controls",
        competencyTitleDescription:
          "The ability to establish enterprise-wide controls related to governance, policy management, and security architecture. Includes frameworks such as ISO 27001 and COBIT.",
        type: "Non Technical",
      },
      {
        competencyTitle: "Compliance Management",
        competencyTitleDescription:
          "The ability to establish, monitor, and maintain compliance with legal, regulatory, and industry standards. It includes developing documentation, conducting audits, producing reports, and ensuring alignment with frameworks such as ISO 27001, GDPR, and other applicable regulations.",
        type: "Non Technical",
      },
    ],
  },
];
export const proficiencies = [
  {
    proficiencyTitle: "Beginner",
    proficiencyDescription:
      "You have a basic awareness of this area. You may have been introduced to key concepts or tools but have limited hands-on experience or formal application.",
    level: "",
  },
  {
    proficiencyTitle: "Intermediate",
    proficiencyDescription:
      "You are comfortable with foundational concepts and tools in this area. You can apply them in common situations and adapt with support when needed.",
    level: "",
  },
  {
    proficiencyTitle: "Expert",
    proficiencyDescription:
      "You demonstrate deep expertise and experience in this area. You apply advanced knowledge independently, solve complex challenges, and contribute to developing best practices.",
    level: "",
  },
  {
    proficiencyTitle: "Leader",
    proficiencyDescription:
      "You define the strategic vision for this area. You influence cross-sector thinking, shape policy or industry direction, and are a trusted voice in national or global contexts.",
    level: "",
  },
  {
    proficiencyTitle: "Not Applicable",
    proficiencyDescription:
      "You have no exposure to or involvement in this area. This competency does not align with your role, expertise, or current scope of responsibility.",
    level: "",
  },
];
